module.exports = __webpack_public_path__ + "img/finland-other-heart-diseases-male.5ffc90e0.png";